exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme--light.v-app-bar.v-toolbar.v-sheet[data-v-4d8f4fdf] {\n  background-color: #fff;\n}\n.theme--dark .v-navigation-drawer[data-v-4d8f4fdf] {\n  background: #274492 !important;\n}\n.theme--dark.v-app-bar.v-toolbar[data-v-4d8f4fdf] {\n  background: #274492 !important;\n}\n.theme--dark.v-application[data-v-4d8f4fdf] {\n  background: #274492 !important;\n}\n.spacing-v-switch[data-v-4d8f4fdf] .v-label {\n  margin-left: 1rem !important;\n}", ""]);

// exports
